<div class="col-12-nav float-center">
    <div class="signin-header">
        <div class="container">
            <section class="logo center-block-wrap">
                <div class="logo-white"></div>
            </section>
        </div>
    </div>
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
        size="medium"
        color="#fff"
        type="line-spin-clockwise-fade"
        [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <div class="col-12">
        <div class="row">
            <div class="col-12 my-4 text-left">
                <h2 class="dark-gray-text">{{'alert.activity' | translate}} - {{'alert.alert_number' | translate}} {{pagination.AlertId}}</h2>
            <div class="mb-3">
                <xng-breadcrumb separator=" > ">
                    <ng-container *xngBreadcrumbItem="let breadcrumb">
                        <span *ngIf="breadcrumb">{{ 'breadcrumb.' + breadcrumb | translate }}</span>
                    </ng-container>
                </xng-breadcrumb>
            </div>
            </div>
            <div class="col-12 text-right">
                <label class="mr-1" for="notes">{{'alert_activity.notes' | translate}}</label>
                <input #noteFilter class="mr-2" type="checkbox" id="notes" (click)="applyFilter(noteFilter.checked)" />
                <a class="custom-hyperlink" (keydown.enter)="chatLog()" (click)="chatLog()" tabindex="0"><i class="fa fa-comments-o" aria-hidden="true"></i> {{'alert.chat_activity' | translate}}</a>
            </div>
            <div class="col-12 my-4 text-right">
                <button id="add_activity" type="button" title="{{'alert_activity.add_note' | translate}}" (click)="openAddActivity()"
                    class="btn btn-blue btn-h-blue mr-1" *ngIf="((alertStatus!=1)&&((agentId==currentUserId && role=='SecurityAgent')||(!['Admin','SecurityAgent'].includes(role))||(role=='SecurityAgent' && alertStatus == 3))&&!expired&&this.userId!=currentUserId)">                    {{'alert_activity.add_note' | translate}}
                </button>&nbsp;
                <a class="custom-hyperlink" tabindex="0" (keydown.enter)="refreshLogs()"  (click)="refreshLogs()"><i class="fa fa-refresh" aria-hidden="true"></i> {{'general.refresh' | translate}}</a>
            </div>
        </div>
        <div class="row" >
            <div class="col-12">
                <div class="card border-top">
                    <div class="space"></div>
                    <div *ngFor="let log of logs">
                        <ul class="timeline" *ngIf="log[3]!=3">
                            <li class="margins">
                                <div class="row dark-gray-text"><strong>{{log[2]}}</strong></div>
                                <div class="row text-dark"> 
                                    <span *ngIf = "log[0] && log[0]!='attend_timer' && log[0]!='close_timer'">{{log[0] | translate}}<span *ngIf="log[1]!=''">&nbsp;</span></span>
                                    <span class="text-left mr-4 text-break" *ngIf="log[0] && (log[3]==0 || log[3]==4) && log[0]!='attend_timer' && log[0]!='close_timer'">{{log[1] | translate}}<span *ngIf="(log[0]!='Nota creada por'&&log[0]!='Note created by')&&(log[3]!='0'&&log[3]!='3')">.</span></span>
                                    <span class="text-left mr-4 text-break" *ngIf="!log[0]">{{"alert_activity.modified_alert_type" | translate: log[1]}}.</span>
                                    <span class="text-left mr-4 text-break" *ngIf="log[0]=='attend_timer' || log[0]=='close_timer'">{{"alert_activity."+log[0] | translate: log[1]}}.</span>
                                    <span *ngIf="log[3]==2">{{log[1] | translate}} Lat.: {{log[6]}} Lng.: {{log[7]}}.
                                        <agm-map [usePanning]="true" [latitude]="log[6]" [zoom]="15" [longitude]="log[7]" [mapTypeId]="'hybrid'" fullscreenControl = true>
                                            <ng-container>
                                                <agm-marker [latitude]="log[6]" [longitude]="log[7]"></agm-marker>
                                            </ng-container>
                                        </agm-map>
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <hr>
                    <div class="col-12">        
                        <mat-paginator tabindex="0" #paginator [pageIndex]="pageIndex" [length]="totalLength" [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons (page)="nextPage($event)"></mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
